export const BASE_URL = "https://patientportalapi.akosmd.in/api/"; //development

export const GET_PRESCRIPTION = "prescription";
export const SAVE_PRESCRIPTION = "prescription/detail";
export const SAVE_MEDICINE = "prescription/medication";
export const GET_MEDICINES = "medicines";
export const DOCTOR_LOGIN = "pcp/doctorLogin";
